import { PREFIX_PHONE } from '../constants';

const NBSP = '\u00a0';

/**
 * Formats a phone number for display in groups of three digits, joined with
 * non-breaking spaces. The `+420` prefix, when present, is its own group.
 * Returns `''` for a missing number, so a loading placeholder keeps its width.
 *
 * @example
 * formatPhoneNumber('777123456'); // '777 123 456'
 * formatPhoneNumber('+420777123456'); // '+420 777 123 456'
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
  const digits = (phone ?? '').replace(/\s/g, '');
  const prefix = digits.startsWith(PREFIX_PHONE) ? PREFIX_PHONE : '';
  const groups = digits.slice(prefix.length).match(/.{1,3}/g) ?? [];

  return [prefix, ...groups].filter(Boolean).join(NBSP);
}

/**
 * Builds a `tel:` link from a phone number as it is written in the copy.
 * Removes whitespace and adds the Czech country code unless the number has one.
 *
 * @example
 * toTelHref('225 852 311'); // 'tel:+420225852311'
 */
export function toTelHref(phone: string): string {
  const digits = phone.replace(/\s/g, '');

  return `tel:${digits.startsWith('+') ? '' : PREFIX_PHONE}${digits}`;
}
